function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "menu-admin",
  "data-name": "Group 14947",
  transform: "translate(-4.064 -2.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3487",
  "data-name": "Path 3487",
  d: "M11.985,15.346c-3.868,0-7.17.585-7.17,2.927s3.282,2.948,7.17,2.948c3.868,0,7.17-.586,7.17-2.927S15.873,15.346,11.985,15.346Z",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3488",
  "data-name": "Path 3488",
  d: "M11.985,12.006a4.58,4.58,0,1,0-.032,0Z",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.429,
  fillRule: "evenodd"
}));

function SvgMenuAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.84,
    height: 19.87,
    viewBox: "0 0 15.84 19.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAdmin);
export default __webpack_public_path__ + "static/media/menu-admin.d4b7aae0.svg";
export { ForwardRef as ReactComponent };